import {createSlice} from '@reduxjs/toolkit';
import {getAdminAccessRightsFailure, getAdminAccessRightsSuccess} from 'src/openapi/admin/apis/GetAdminAccessRightsApi';

import type {AppState} from 'src/store/typedef';


export const initialState: {
    list: Array<string> | null,
} = {
    list: null,
};

export const accessRightsSlice = createSlice({
    name: 'accessRights',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getAdminAccessRightsSuccess, (state, action) => {
                state.list = [...action.payload.data];
            })
            .addCase(getAdminAccessRightsFailure, state => {
                state.list = [];
            });
    },
});


export const selectAccessRights: (state: AppState) => Array<string> | null = state => {
    return state.accessRights.list;
};
